import React from 'react';
import { Link } from 'react-router-dom';
import { BookCallButton } from './BookCallButton';
export function Navbar() {
  return <nav className="w-full pt-6 pb-2 px-6 md:px-12 flex items-center justify-between max-w-7xl mx-auto" data-id="element-99">
      <Link to="/" className="flex items-center" aria-label="Year One Mentor home" data-id="element-100">
        <img src="https://cdn.magicpatterns.com/uploads/c9sWKrnv1vxYm1ZPgVh9dm/ChatGPT_Image_May_13,_2026,_09_40_06_PM.png" alt="Year One Mentor" className="h-[66px] md:h-[80px] w-auto" data-id="element-101" />
      </Link>

      <div className="hidden md:flex items-center gap-8 text-sm font-medium text-ink/80" data-id="element-102">
        <Link to="/#coaching" className="hover:text-teal transition-colors" data-id="element-103">
          Coaching
        </Link>
        <Link to="/#programs" className="hover:text-teal transition-colors" data-id="element-104">
          Programs
        </Link>
        <Link to="/#resources" className="hover:text-teal transition-colors" data-id="element-105">
          Resources
        </Link>
        <Link to="/about" className="hover:text-teal transition-colors" data-id="element-106">
          About
        </Link>
      </div>

      <div className="hidden md:block" data-id="element-107">
        <BookCallButton className="btn-primary py-2.5 text-sm" data-id="element-108" />
      </div>
    </nav>;
}